import type { Card, Row } from '@/lib/qcp/protocol';

/**
 * Il TRASCINAMENTO di una carta della mano sul tavolo del Chinese Poker (I-798, fase B): le parti pure.
 * Il trascinamento si AGGIUNGE al tocco-tocco (che resta com'e): prende una carta della mano, la lascia su una delle MIE file, e la mossa passa dallo STESSO percorso del tocco
 * (`useOfcPlacement.placeTo`, dalla rotta) — qui non c'e nessuna regola di piazzamento, solo «dov'e il dito».
 */

/** Sotto questa distanza (px, in linea d'aria) dal punto in cui si e posato il dito e un TOCCO, sopra e un trascinamento: un tocco con un po di tremolio resta un tocco. */
export const SOGLIA_TRASCINA_PX = 8;
export const haTrascinato = (dx: number, dy: number): boolean => Math.hypot(dx, dy) >= SOGLIA_TRASCINA_PX;

const FILA_DA_ETICHETTA: Record<string, Row> = { TOP: 'front', MID: 'middle', BOT: 'back' };

/**
 * La fila della MIA plancia sotto il punto (x, y) dello schermo, o `null` fuori da ogni fila. Solo le file dentro `[data-plancia-mia]`: quelle dell'avversario e del resoconto non sono bersagli.
 * Si legge dal DOM (`elementsFromPoint`) e non da rettangoli calcolati: nel palco il tavolo e scalato, e girato di 90° col telefono in piedi, e il DOM e l'unico che lo sa.
 */
export function filaSotto(x: number, y: number): Row | null {
  const elementi = typeof document.elementsFromPoint === 'function' ? document.elementsFromPoint(x, y) : [];
  for (const el of elementi) {
    const fila = el.closest('[data-plancia-mia] [data-fila]');
    const riga = fila?.getAttribute('data-fila');
    if (riga && riga in FILA_DA_ETICHETTA) return FILA_DA_ETICHETTA[riga];
  }
  return null;
}

/** Cio che la mano dice alla rotta durante un trascinamento. La rotta decide cosa vuol dire (selezione, bersagli, piazzata): la mano non sa niente delle regole. */
export interface TrascinaMano {
  /** Il dito ha superato la soglia: la carta e «presa». */
  onInizio: (card: Card) => void;
  /** La fila sotto il dito e cambiata (`null` = nessuna). */
  onSopra: (fila: Row | null) => void;
  /** Il dito e stato sollevato (`fila` = quella sotto il dito) o il gesto e stato annullato (`fila: null`). */
  onRilascio: (card: Card, fila: Row | null) => void;
}

/**
 * La carta appena LASCIATA col dito su una fila: la copia che seguiva il dito e gia arrivata li, quindi la carta, quando compare nella fila, NON deve volare dalla mano (era il «saltello» di
 * I-807: spariva sotto il dito e ricompariva volando dalla mano). Un modulo, non uno stato React: lo scrive il gesto (`DrawTray`), lo legge il confronto delle posizioni (`useVoloCarte`)
 * nel render subito dopo, e basta un istante di memoria.
 */
const FINESTRA_RILASCIO_MS = 1500;
let ultimoRilascio: { chiave: string; quando: number } | null = null;
export const segnaRilascioColDito = (chiave: string, adesso: number = Date.now()): void => {
  ultimoRilascio = { chiave, quando: adesso };
};
export const eraRilasciataColDito = (chiave: string, adesso: number = Date.now()): boolean => ultimoRilascio !== null && ultimoRilascio.chiave === chiave && adesso - ultimoRilascio.quando < FINESTRA_RILASCIO_MS;
